(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["image-hotspots"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    const container = document.getElementById('hotspots');
    if (!container) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) animateHotspots();
        });
      },
      { threshold: 0.3 }
    );

    observer.observe(container);

    function animateOne(i) {
      const label = document.getElementById(`hotspot-label-${i}`);
      const target = document.getElementById(`hotspot-target-${i}`);
      const line = document.getElementById(`hotspot-line-${i}`);

      if (!label || !target || !line) return;

      const r1 = label.getBoundingClientRect();
      const r2 = target.getBoundingClientRect();
      const c = container.getBoundingClientRect();

      // Text-Ausrichtung bestimmen
      const align = window.getComputedStyle(label).textAlign;

      // LINE START: unten links oder unten rechts
      const startX = (align === 'right' ? r1.right : r1.left) - c.left;
      const startY = r1.bottom - c.top;

      // LINE END: Mittelpunkt des Zielpunkts
      const endX = r2.left + r2.width / 2 - c.left;
      const endY = r2.top + r2.height / 2 - c.top;

      const dx = endX - startX;
      const dy = endY - startY;
      const distance = Math.sqrt(dx * dx + dy * dy);
      const angle = Math.atan2(dy, dx) * (180 / Math.PI);

      line.style.top = startY + 'px';
      line.style.left = startX + 'px';
      line.style.transform = `rotate(${angle}deg)`;

      requestAnimationFrame(() => {
        line.style.width = distance + 'px';
        line.classList.add('visible');
      });
    }

    function animateHotspots() {
      animateOne(1);
      animateOne(2);
      animateOne(3);
      animateOne(4);
      animateOne(5);
      animateOne(6);
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["social-proof"] && !Shopify.designMode) return;
  try {
    const container = document.querySelector('.js-sp-container');
  const rotator = container?.querySelector('.js-sp-avatar-rotator');

  if (container && rotator) {
    let interval = parseInt(container.dataset.rotation) || 3000;

    function updateClasses() {
      const avatars = Array.from(rotator.children);
      avatars.forEach((el, idx) => {
        el.classList.toggle('first', idx === 0);
      });
    }

    updateClasses();

    setInterval(() => {
      const avatars = Array.from(rotator.children);
      const current = avatars[0];

      current.classList.add('fade-out');

      setTimeout(() => {
        current.classList.remove('fade-out');
        rotator.appendChild(current);
        updateClasses();

        const incoming = rotator.lastElementChild;
        incoming.classList.add('fade-in');

        setTimeout(() => incoming.classList.add('active'), 20);

        setTimeout(() => {
          incoming.classList.remove('fade-in', 'active');
        }, 600);
      }, 500);
    }, interval);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["tab-switcher"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-switcher]').forEach((switcher) => {
      console.log('switcher');
      const buttons = switcher.querySelectorAll('[data-switcher-button]');
      const panels = switcher.querySelectorAll('[data-switcher-panel]');

      buttons.forEach((btn) => {
        btn.addEventListener('click', () => {
          const id = btn.dataset.switcherButton;

          buttons.forEach((b) => b.classList.remove('active'));
          panels.forEach((p) => p.classList.remove('active'));

          btn.classList.add('active');
          switcher.querySelector(`[data-switcher-panel="${id}"]`).classList.add('active');
        });
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
